import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { expVal } from '@confluence/feature-experiments';

import EndOfPageRecommendationQuery from './__generated__/EndOfPageRecommendationQuery.graphql.ts';

export function preloadEndOfPageRecommendation({ contentId, spaceKey, contentType }) {
	return query({
		query: EndOfPageRecommendationQuery,
		variables: {
			type: contentType,
			id: contentId,
			exp: expVal('cc_ai_discovery_linked_pages_on_related_pages', 'experience', 'end_of_page_v5'),
			key: spaceKey,
			keyString: spaceKey,
		},
	});
}
